<template>
  <nav aria-label="breadcrumb" class="breadcrumb">
    <ul>
      <li v-for="(crumb, index) in breadcrumbs" :key="index">
        <router-link v-if="index !== breadcrumbs.length - 1" :to="crumb.path">
          {{ $t(crumb.label) }}
        </router-link>
        <span v-else>
          {{ $t(crumb.label) }}
        </span>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()

const routeNameToI18nKey = {
  home: 'nav.home',
  galerija: 'nav.gallery'
}

const breadcrumbs = computed(() => {
  const pathArray = route.path.split('/').filter(Boolean)

  const crumbs = [{ path: '/', label: 'nav.home' }]

  let accumulatedPath = ''
  pathArray.forEach(segment => {
    accumulatedPath += '/' + segment
    const label = routeNameToI18nKey[segment] || segment
    crumbs.push({ path: accumulatedPath, label })
  })

  return crumbs
})
</script>

<style scoped>
.breadcrumb {
  padding: 0.5rem 1rem;
  background-color: #f5f5f5;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.breadcrumb ul {
  list-style: none;
  display: flex;
  gap: 0.5rem;
  padding: 0;
  margin: 0;
}

.breadcrumb li::after {
  content: '/';
  margin-left: 0.5rem;
}

.breadcrumb li:last-child::after {
  content: '';
}

.breadcrumb a {
  color: #4a6e58;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb span {
  color: #555;
}
</style>

